import { useTranslation } from "react-i18next";
import { Ban, Wallet } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";

// السلف موقوفة في سياسة الفرع: يبقى الكرت ظاهراً بعلامة مائية بدل إخفائه.
export const AdvanceWatermark = ({ reason = "advances_disabled" }) => {
  const { t } = useTranslation();
  return (
    <NeuCard className="relative overflow-hidden" data-testid="advance-watermark">
      <div className="flex items-start justify-between gap-3 opacity-40">
        <p className="label-xs">{t("advances.title")}</p>
        <Wallet className="h-5 w-5 text-primary" />
      </div>
      <p className="mt-4 max-w-md text-sm text-muted-foreground opacity-60">{t(`advances.${reason}`)}</p>

      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <p className="flex -rotate-12 items-center gap-3 select-none text-2xl font-black tracking-widest text-destructive/35 sm:text-4xl">
          <Ban className="h-8 w-8 sm:h-10 sm:w-10" /> {t("advances.stopped")}
        </p>
      </div>
    </NeuCard>
  );
};
